
import Progress from 'bee-progress'
export default Progress
